<template>
    <div class="el-table-container templateBox">
        <div class="query-form">
            <el-tabs v-model="searchForm.status" @tab-click="handleClick">
                <el-tab-pane v-for="item in pageTypeList" :key="item.name" :label="item.name"
                             :name="item.value"></el-tab-pane>
            </el-tabs>
        </div>
        <div class="query-form">
            <el-button v-if="hasPermission('collection:outbound:toExamine:through')"
                       @click="examineData(0)" size="small">审核通过
            </el-button>
            <el-button v-if="hasPermission('collection:outbound:toExamine:reject')"
                       @click="examineData(1)" size="small">审核驳回
            </el-button>
        </div>
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1)" @submit.native.prevent label-width="90px">
            <el-form-item label="出库原因" prop="outWarehouseCause">
                <el-select v-model="searchForm.outWarehouseCause" clearable placeholder="请选择出库原因">
                    <el-option
                            v-for="item in $dictUtils.getDictList('out_warehouse_cause')"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="出库日期" prop="outDataTime">
                <el-date-picker
                    v-model="searchForm.outDataTime"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="预入库时间" prop="dataTime">
                <el-date-picker
                        v-model="searchForm.dataTime"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="出库申请人" prop="applicant">
                <el-select v-model="searchForm.applicant" clearable placeholder="请选择出库申请人">
                    <el-option
                        v-for="item in applicantList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="tips">
            <el-link class="el-icon-info" type="primary" :underline="false"></el-link>
            已选择{{ dataListSelections.length }}项数据
        </div>
        <el-table
                :data="dataList"
                size="small" height="100%"
                class="table" ref="multipleTable" border
                @selection-change="selectionChangeHandle" row-key='id' v-loading="loading">
            <el-table-column type="selection" :reserve-selection='true' fixed/>
            <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="outWarehouseCause" label="出库原因" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <div>{{ $dictUtils.getDictLabel("out_warehouse_cause", row.outWarehouseCause, '') }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="preInWarehouseTime" label="预回库日期" show-overflow-tooltip></el-table-column>
            <el-table-column prop="applicant" label="申请人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="applicantTime" label="申请时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="审批状态" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <div>{{ $dictUtils.getDictLabel("collection_status", row.status, '') }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
            <el-table-column fixed="right" label="操作" min-width="150">
                <template slot-scope="{row,$index}">
                    <el-button v-if="hasPermission('collection:outbound:outboundList:view')" type="text" size="small"
                               @click="addData('view',row,$index)">详情
                    </el-button>
                    <el-button v-show="searchForm.status == 0" v-if="hasPermission('collection:outbound:toExamine:through')" type="text" size="small"
                               @click="examineData(0,row)">通过
                    </el-button>
                    <el-button v-show="searchForm.status == 0" v-if="hasPermission('collection:outbound:toExamine:reject')" type="text" size="small"
                               @click="examineData(1,row)">驳回
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <detail-outbound ref="detailOutbound" @itemsChange="itemsChange"></detail-outbound>
        <set-toexamine ref="setToexamine" @refresh="refreshList('',1)"></set-toexamine>
    </div>
</template>

<script>

import DetailOutbound from "@/views/modules/collection/outbound/detailOutbound.vue";
import SetToexamine from "@/views/modules/collection/outbound/setToexamine.vue";

export default {
    name: "toExamine",
    components: {SetToexamine, DetailOutbound},
    data() {
        return {
            searchForm: {
                status: '0',
                outWarehouseCause: '',
                applicant: '',
                dataTime: [],
                startPreOutWarehouseTime: '',
                endPreOutWarehouseTime: '',
                outDataTime:[],
                startOutWarehouseTime:'',
                endOutWarehouseTime:'',
                current: 1,
                size: 20,
            },
            applicantList: [],
            pageTypeList: [
                {
                    name: '待审核',
                    value: '0',
                },
                {
                    name: '已审核',
                    value: '1',
                },
            ],

            loading: false,
            dataList: [],
            dataListSelections: [],
            total: 0,
            searchData: {},
            detailCurrt:0,
        }
    },

    mounted() {
        this.refreshList()
        this.getOthers()
    },

    methods: {
        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            this.loading = true
            this.searchData = JSON.parse(JSON.stringify(this.searchForm))
            if (this.searchData.status == '99') {
                this.searchData.status = ''
            }
            if (this.searchData.dataTime && this.searchData.dataTime.length) {
                this.searchData.startPreOutWarehouseTime = this.searchData.dataTime[0]
                this.searchData.endPreOutWarehouseTime = this.searchData.dataTime[1]
            } else {
                this.searchData.startPreOutWarehouseTime = ''
                this.searchData.endPreOutWarehouseTime = ''
            }
            if (this.searchData.outDataTime && this.searchData.outDataTime.length) {
                this.searchData.startOutWarehouseTime = this.searchData.outDataTime[0]
                this.searchData.endOutWarehouseTime = this.searchData.outDataTime[1]
            } else {
                this.searchData.startOutWarehouseTime = ''
                this.searchData.endOutWarehouseTime = ''
            }
            this.$axios(this.api.collection.collectionoutwarehouseRevdlist, this.searchData).then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
            this.$axios(this.api.collection.revdTabCount).then(data => {
                if (data && data.status) {
                    this.pageTypeList = [
                        {
                            name: '待审核',
                            value: '0',
                        },
                        {
                            name: '已审核',
                            value: '1',
                        },
                    ]
                    this.pageTypeList[0].name += '(' + data.data.noHandle + ')'
                    this.pageTypeList[1].name += '(' + data.data.handle + ')'
                }
            })
        },

        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1)
        },

        //获取其他信息
        getOthers() {
            this.$axios(this.api.collection.outWarehouseApplyUser).then(data => {
                if (data && data.status) {
                    this.applicantList = data.data
                }
            })
        },

        handleClick() {
            this.refreshList(1, 1)
        },

        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },

        // name add新增 view详情 edit编辑
        addData(name, row,index) {
            if (name == 'view'){
                this.detailCurrt = (this.searchForm.current - 1) * this.searchForm.size + index + 1
                this.$refs.detailOutbound.init(row,'toExamine')
            }
        },

        //type 0通过 1驳回
        examineData(status,row){
            let list = row ? [row] : this.dataListSelections
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let ids = list.map(item => {
                return item.id
            })
            let type = status == 0 ? 'through' : 'reject'
            let url = status == 0 ? this.api.collection.batchSuccess : this.api.collection.batchReject
            this.$refs.setToexamine.init(ids,type,url)
        },

        //0上一条 1下一条
        itemsChange(type){
            if (type == 0){
                if (this.detailCurrt == 1){
                    this.$message.info('已是第一条')
                    return
                }else {
                    this.detailCurrt --
                }
            }else {
                if (this.detailCurrt == this.total){
                    this.$message.info('已是最后一条')
                    return
                }else {
                    this.detailCurrt ++
                }
            }
            this.$axios(this.api.collection.collectionoutwarehouseRevdlist, {
                ...this.searchData,
                current:this.detailCurrt,
                size:1,
            }).then(data => {
                if (data && data.status) {
                    this.$refs.detailOutbound.init(data.data.records[0])
                } else {
                    this.$message.error('查询失败')
                }
            })
            // this.$emit('itemsChange',type)
        },
    },
}
</script>

<style scoped>
.tips {
    padding: 4px;

    .el-icon-info {
        margin-right: 6px;
    }
}
</style>